import { Box, Button, CircularProgress, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  DocumentUploadIcon,
  PreviewIcon,
} from "../../assets/Icon/dashboredIcon";

import { Grid } from "@mui/system";
import { useSelector } from "react-redux";
import useDownloader from "react-use-downloader";
import ApiHelperFunction from "../../api";
import { EditIconTable } from "../../assets/Icon/ArrowIcon";
import {
  MessaageArrowUpIcon,
  MessaageRightIcon,
} from "../../assets/Icon/OrderDetailIcon";
import img1 from "../../assets/Images/image1.png";
import img2 from "../../assets/Images/image2.png";
import img3 from "../../assets/Images/imagePassport.png";
import img4 from "../../assets/Images/image4.png";
import img5 from "../../assets/Images/image5.png";
import MessageBox from "../../pages/orders/MessageBox";
import MessageEditor from "../../pages/orders/MessageEditor";
import { StyledGridBox } from "../../pages/orders/OrderDetails";
import { StepperContext } from "../../stepper/context/StepperContext";
import { getUrl } from "../../stores/incorporation";
import {
  getItin,
  getMessageData,
  handleSendMessage,
  setMessage,
  setNewMessage,
} from "../../stores/orders";
import { useAppDispatch } from "../../stores/store";
import theme from "../../theme";
import { localName } from "../../utils/StorageUtils";
import BackPageButton from "../common-components/BackPageButton";
import ListLoadingNew from "../common-components/ListLoadingNew";
import NoDataFound from "../common-components/NoDataFound";
import TitleBar from "../common-components/TitleBar";
import {
  StyledContainer,
  StyledListContainer,
  StyledListItem,
  StyledListItemContent,
  StyledListItemText,
  StyledTitle,
} from "../style/ititn/DeatilStyle";
import PreviewModal from "./PreviewModal";
import UploadSignComponentItin from "./UploadSignComonentItin";
interface StepProp {
  handleUpdate?: (data: any) => void;
  formData?: any;
}

interface ListItemData {
  img: string;
  text: string;
  key: string;
}

type Countdown = {
  weeks: number;
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  isExpired: boolean;
};

const EIGHT_WEEKS_MS = 8 * 7 * 24 * 60 * 60 * 1000;

const allDocuments: ListItemData[] = [
  { img: img1, text: "Business Incorporation", key: "business_incorporation" },
  { img: img2, text: "EIN Document", key: "ein_document" },
  { img: img3, text: "Scanned Passport", key: "scan_passport" },
  { img: img4, text: "W-7 Form", key: "w7_form" },
  { img: img5, text: "2848 Form", key: "form_2848" },
  { img: img4, text: "W -7 Form with Signature", key: "w7_signed_form" },
  { img: img5, text: "2848 Form With Signature", key: "form_2848_signed_form" },
  // { img: img5, text: "Verified Form File", key: "verified_form_files" },
];

const ApplyDetail = (props: StepProp) => {
  const { state } = useLocation();
  const { value } = state || {};
  const dispatch = useAppDispatch();
  const [edit, setEdit] = useState(false);
  const [showUploadSign, setShowUploadSign] = useState(false);
  const [edit2848, setEdit2848] = useState(false);
  const [itinStatus, setItinStatus] = useState(0);
  const [orderData, setOrderData] = useState<any>(null);
  const [documentData, setDocumentData] = useState<Record<string, string>>({});
  const token = localStorage.getItem("user_token");
  const [openPreview, setOpenPreview] = useState(false);
  const [img, setImg] = useState("");
  const [getLoading, setGetLoading] = useState(true);
  const [downloadingFile, setDownloadingFile] = useState<string | null>(null);
  const [isMessageBox, setIsMessageBox] = useState<boolean>(false);
  const stepperState = useContext(StepperContext);
  const messageEndRef = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [sentMessage, setSentMessage] = useState<string[]>([]);
  const [sending, setSending] = useState(false);
  const [showMessageContent, setShowMessageContent] = useState<boolean>(false);
  const [selectedFiles, setSelectedFiles] = useState<
    { file: File; preview: string }[]
  >([]);
  const [time, setTime] = useState<Countdown>({
    weeks: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    isExpired: false,
  });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const { fetchMessgaeData, typeMessage, itinDetails, messageDetails } =
    useSelector((state: any) => state.orders);
  const selectedOrder = useSelector((state: any) => state.orders.selectedOrder);
  const baseUrl = process.env.REACT_APP_BASE_IMAGE_URL || "";
  const { download } = useDownloader();

  useEffect(() => {
    getItinData();
    setDocumentData(itinDetails);
  }, []);
  const handleClose = () => {
    setOpenPreview(false);
  };
  const getData = async () => {
    setGetLoading(true);
    try {
      const response = await ApiHelperFunction({
        url: `/get-itin-data/?order_id=${id}`,
        method: "GET",
        headers: {
          Authorization: token ? `${token}` : "",
        },
      });

      if (response?.data?.status === 1) {
        setGetLoading(false);
        setDocumentData(response?.data?.data || {});
        setItinStatus(response?.data?.data?.status);
      }
      if (response?.data?.status === 0) {
        setGetLoading(false);
        return;
      }
    } catch (error) {
      setGetLoading(false);
    }
  };

  const getItinData = async () => {
    setGetLoading(true);
    const response = await dispatch<any>(getItin({ order_id: id }));
    if (response) {
      setDocumentData(response?.payload?.data);
      setItinStatus(response?.payload?.data?.status);
      setOrderData(response?.payload?.order);
    }
    setGetLoading(false);
  };

  const availableDocuments = allDocuments.filter(
    (doc) => documentData[doc.key]
  );

  useEffect(() => {
    if (showMessageContent && messageEndRef.current) {
      messageEndRef.current.scrollIntoView({ behavior: "smooth" });
      document.getElementById("messgeContent")?.scrollTo({
        top: document.getElementById("messgeContent")?.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [showMessageContent, isMessageBox, fetchMessgaeData]);

  const handleEdit = (key: string) => {
    if (
      ["scan_passport", "business_incorporation", "ein_document"].includes(key)
    ) {
      setTimeout(() => {
        navigate(`/itin/${id}/edit-documents`);
      }, 300);
    } else if (key === "w7_form") {
      setTimeout(() => {
        navigate(`/itin/${id}/edit-w7`);
      }, 300);
    } else if (key === "w7_signed_form") {
      setEdit(true);
    } else if (key === "form_2848_signed_form") {
      setEdit2848(true);
    }
  };
  const sendMessage = async () => {
    setSending(true);
    const newMessage = typeMessage
      .replace(/<p><br\s*\/?><\/p>/gi, "")
      .replace(/<[^>]*>/g, "")
      .replace(/\s+/g, " ")
      .trim();

    if (!newMessage && selectedFiles.length === 0) {
      return;
    }
    try {
      const formData = new FormData();
      formData.append("message", typeMessage || "");
      selectedFiles.forEach((fileObj: any, index: number) => {
        formData.append("files", fileObj.file);
      });
      const newdata = {
        message: typeMessage,
        sender_name: localName,
        files: selectedFiles.map((fileObj: any) => fileObj.file),
      };
      dispatch<any>(setNewMessage(newdata));
      const result = await dispatch<any>(
        handleSendMessage({
          user_id: Number(documentData?.user_id),
          order_id: id,
          formData,
        })
      );
      setSentMessage((prev) => [...prev, typeMessage]);

      // getMessage(false);
      dispatch<any>(setMessage(""));
      setSelectedFiles([]);
      setSentMessage([]);
      // setSupportId(result.payload.data.id);
      // if (result.payload.status == 1) {
      //   setIsMessageBox(true);
      // }
    } catch (error) {
      // Optional: show error toast or handle error
    } finally {
      setSending(false);
    }
  };
  const [isMessageLoading, setIsMessageLoading] = useState(true);
  const getMessage = async (showLoader: boolean = true) => {
    if (showLoader) {
      setIsMessageLoading(true);
    }
    try {
      const result = await dispatch<any>(
        getMessageData({ user_id: documentData?.user_id, order_id: id })
      );
      if (showLoader) {
        setIsMessageLoading(false);
      }

      // setSupportId(result.payload.data.id);
    } catch (error) {
      if (showLoader) {
        setIsMessageLoading(false);
      }
      // Optional: show error toast or handle error
    }
  };
  useEffect(() => {
    if (documentData?.user_id) {
      getMessage();
    }
  }, [documentData?.user_id]);

  const hasSignedForms =
    documentData["w7_form"] !== null &&
    documentData["form_2848"] !== null &&
    documentData["form_2848_signed_form"] === null &&
    documentData["w7_signed_form"] === null;

  useEffect(() => {
    if (hasSignedForms) {
      setShowUploadSign(true);
    }
  }, [hasSignedForms]);

  const hasVerifiedForms =
    Array.isArray(documentData["verified_form_files"]) &&
    documentData["verified_form_files"].length > 0;

  const handleDownloadUrl = async (url: string) => {
    try {
      setDownloadingFile(url);
      const response = await dispatch<any>(getUrl({ url: url }));
      const fileUrl = response?.payload?.data;
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = fileUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      setDownloadingFile(null);
      // Optionally, display an error message to the user
    } finally {
      setDownloadingFile(null);
    }
  };

  const get8WeekCountdown = (startTime: string): Countdown => {
    const startDate = new Date(startTime).getTime();
    const endDate = startDate + EIGHT_WEEKS_MS;
    const now = Date.now();

    let diff = endDate - now;

    if (diff <= 0) {
      return {
        weeks: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        isExpired: true,
      };
    }

    const weeks = Math.floor(diff / (7 * 24 * 60 * 60 * 1000));
    diff %= 7 * 24 * 60 * 60 * 1000;

    const days = Math.floor(diff / (24 * 60 * 60 * 1000));
    diff %= 24 * 60 * 60 * 1000;

    const hours = Math.floor(diff / (60 * 60 * 1000));
    diff %= 60 * 60 * 1000;

    const minutes = Math.floor(diff / (60 * 1000));
    diff %= 60 * 1000;

    const seconds = Math.floor(diff / 1000);

    return {
      weeks,
      days,
      hours,
      minutes,
      seconds,
      isExpired: false,
    };
  };

  const { weeks, days, hours, minutes, seconds } = time;
  useEffect(() => {
    if (!documentData?.irs_submission_timestamp) return;

    const interval = setInterval(() => {
      const countdown = get8WeekCountdown(
        documentData.irs_submission_timestamp
      );

      setTime(countdown); // 🔥 UPDATE STATE

      if (countdown.isExpired) {
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [documentData?.irs_submission_timestamp]);

  const format2Digits = (value: number) => String(value).padStart(2, "0");


  return (
    <Box>
      {getLoading ? (
        <ListLoadingNew />
      ) : availableDocuments.length === 0 ? (
        <NoDataFound
          title="ITIN Data Not Found"
          subTitle="You haven't added any ITIN details yet, so no data is available. Please update your information to view the details."
          status={true}
        />
      ) : (
        <>
          <BackPageButton />
          <div
            style={{
              display: isMobile ? "block" : "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              marginBottom: "20px",
            }}
          >
            <div style={{ marginTop: 14 }}><TitleBar title="ITIN Details" /></div>

            {orderData?.is_expedite_addon && documentData.irs_submission_timestamp && (
              <div>
                
                  <div
                    style={{
                      background: "#2977CC",
                      borderRadius: "6px",
                      display: "grid",
                      gap: "5px",
                      padding: "8px 8px",
                      alignItems: "center",
                      width: "fit-content",
                    }}
                  >
                    <div style={{
                      textAlign: "center",
                      fontSize: "12px",
                      color: "#fff",
                      fontWeight: 500,
                    }}>ITIN Countdown</div>
                    {weeks && hours && days && minutes && seconds ? (<div style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                    }}>
                    <p style={{ width: "49px", height: "44px", display: "flex", flexDirection: "column", alignItems: "center", gap: 3, justifyContent: "center", textAlign: "center", color: "white", background: ` linear-gradient(#4D8ED5, #4D8ED5) padding-box, linear-gradient(to right, #2977CC, #1D538F) border-box `, border: "1px solid transparent", borderRadius: "6px", fontWeight: 800, fontSize: "15px", lineHeight: 1.1, }} >
                      {format2Digits(weeks)}
                      <span style={{ fontSize: "10px", fontWeight: 400 }}>
                        Week
                      </span>
                    </p>
                    <p style={{ width: "49px", height: "44px", display: "flex", flexDirection: "column", alignItems: "center", gap: 3, justifyContent: "center", textAlign: "center", color: "white", background: ` linear-gradient(#4D8ED5, #4D8ED5) padding-box, linear-gradient(to right, #2977CC, #1D538F) border-box `, border: "1px solid transparent", borderRadius: "6px", fontWeight: 800, fontSize: "15px", lineHeight: 1.1, }} >
                      {format2Digits(days)}
                      <span style={{ fontSize: "10px", fontWeight: 400 }}>
                        Days
                      </span>
                    </p>
                    <p style={{ width: "49px", height: "44px", display: "flex", flexDirection: "column", alignItems: "center", gap: 3, justifyContent: "center", textAlign: "center", color: "white", background: ` linear-gradient(#4D8ED5, #4D8ED5) padding-box, linear-gradient(to right, #2977CC, #1D538F) border-box `, border: "1px solid transparent", borderRadius: "6px", fontWeight: 800, fontSize: "15px", lineHeight: 1.1, }} >
                      {format2Digits(hours)}
                      <span style={{ fontSize: "10px", fontWeight: 400 }}>
                        Hrs
                      </span>
                    </p>
                    <p style={{ width: "49px", height: "44px", display: "flex", flexDirection: "column", alignItems: "center", gap: 3, justifyContent: "center", textAlign: "center", color: "white", background: ` linear-gradient(#4D8ED5, #4D8ED5) padding-box, linear-gradient(to right, #2977CC, #1D538F) border-box `, border: "1px solid transparent", borderRadius: "6px", fontWeight: 800, fontSize: "15px", lineHeight: 1.1, }} >
                      {format2Digits(minutes)}
                      <span style={{ fontSize: "10px", fontWeight: 400 }}>
                        Min
                      </span>
                    </p>
                    <p style={{ width: "49px", height: "44px", display: "flex", flexDirection: "column", alignItems: "center", gap: 3, justifyContent: "center", textAlign: "center", color: "white", background: ` linear-gradient(#4D8ED5, #4D8ED5) padding-box, linear-gradient(to right, #2977CC, #1D538F) border-box `, border: "1px solid transparent", borderRadius: "6px", fontWeight: 800, fontSize: "15px", lineHeight: 1.1, }} >
                      {format2Digits(seconds)}
                      <span style={{ fontSize: "10px", fontWeight: 400 }}>
                        Sec
                      </span>
                    </p>
                    </div>
                    ) : (
                  <div
                    style={{
                      color: "white",
                      height: "44px",
                      background: "#2977CC",
                      borderRadius: "6px",
                      display: "flex",
                      gap: "10px",
                      padding: "8px 12px",
                      alignItems: "center",
                      fontSize: "14px",
                      width: "285px",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CircularProgress size={16} color="inherit" /> Loading... 
                  </div>
                )}
                  </div>
              </div>
            )}
          </div>

          <StyledContainer>
            <StyledTitle>Uploaded Documents</StyledTitle>
            <StyledListContainer>
              {availableDocuments.map((item, index) => (
                <StyledListItem key={index}>
                  <StyledListItemContent>
                    <StyledListItemText>
                      <img
                        key={item.key}
                        src={item.img}
                        // src={ item.key === "scan_passport" ? `${baseUrl}${documentData[item.key]}` : item.img}
                        alt={item.text}
                        style={{
                          objectFit: "cover",
                          height: "37px",
                          width: "40px",
                        }}
                        onError={(e) => {
                          if (
                            item.key === "business_incorporation" ||
                            item.key === "ein_document" ||
                            item.key === "scan_passport"
                          ) {
                            (e.target as HTMLImageElement).style.display =
                              "none";
                          } else {
                            (e.target as HTMLImageElement).src = item.img;
                          }
                        }}
                      />
                      <Typography
                        variant="h5"
                        sx={{ color: theme.palette.myCustomColor.dark }}
                      >
                        {item.text}
                      </Typography>
                    </StyledListItemText>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        cursor: "pointer",
                      }}
                    >
                      {(itinStatus === 1 || itinStatus === 2) &&
                        !["form_2848", "verified_form_files"].includes(
                          item.key
                        ) && (
                          <span
                            onClick={() => {
                              handleEdit(item.key);
                            }}
                          >
                            <EditIconTable />
                          </span>
                        )}
                      <span
                        onClick={() => {
                          setOpenPreview(true);
                          setImg(`${baseUrl}${documentData[item.key]}`);
                          // setImg(`${documentData[item.key]}`);
                        }}
                      >
                        <PreviewIcon />
                      </span>

                      <span
                        onClick={() => {
                          handleDownloadUrl(documentData[item.key]);
                        }}
                      >
                        {downloadingFile === documentData[item?.key] ? (
                          <>
                            <CircularProgress
                              sx={{
                                width: "31px !important",
                                height: "30px !important",
                              }}
                            />
                          </>
                        ) : (
                          <DocumentUploadIcon />
                        )}
                      </span>
                    </Box>
                  </StyledListItemContent>
                </StyledListItem>
              ))}

              {hasVerifiedForms && (
                <>
                  <StyledListItem>
                    <StyledListItemContent>
                      <StyledListItemText>
                        <img
                          src={img5}
                          alt={""}
                          style={{
                            objectFit: "cover",
                            height: "37px",
                            width: "40px",
                          }}
                          onError={(e) => {}}
                        />
                        <Typography
                          variant="h5"
                          sx={{ color: theme.palette.myCustomColor.dark }}
                        >
                          ITIN Document
                        </Typography>
                      </StyledListItemText>

                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                          cursor: "pointer",
                        }}
                      >
                        <span
                          onClick={() => {
                            setOpenPreview(true);
                            setImg(
                              `${baseUrl}${documentData?.verified_form_files[0]}`
                            );
                          }}
                        >
                          <PreviewIcon />
                        </span>
                        <span
                          onClick={() => {
                            handleDownloadUrl(
                              documentData?.verified_form_files[0]
                            );
                          }}
                        >
                          {downloadingFile ===
                          documentData?.verified_form_files[0] ? (
                            <>
                              <CircularProgress
                                sx={{
                                  width: "31px !important",
                                  height: "30px !important",
                                }}
                              />
                            </>
                          ) : (
                            <DocumentUploadIcon />
                          )}
                        </span>
                      </Box>
                    </StyledListItemContent>
                  </StyledListItem>
                </>
              )}
            </StyledListContainer>
          </StyledContainer>
          {(hasSignedForms || edit || edit2848 || showUploadSign) && (
            <UploadSignComponentItin
              handlePrev={() => ""}
              edit={edit}
              hasSigned={hasSignedForms}
              uploadedFileW7={edit ? documentData["w7_signed_form"] : null}
              uploadedFile2848={
                edit2848 ? documentData["form_2848_signed_form"] : null
              }
              edit2848={edit2848}
              onCancelEdit={() => {
                setEdit(false);
                setEdit2848(false);
              }}
              onSuccess={() => {
                setShowUploadSign(false);
                setEdit(false);
                setEdit2848(false);
                dispatch<any>(getItin({ order_id: id }));
              }}
            />
          )}
          <Grid container spacing={2} sx={{ marginTop: 2 }}>
            <StyledGridBox
              size={{ xs: 12, md: 12 }}
              sx={{
                // border: "2px solid #EAF1FA",
                borderRadius: "12px",
                background: "#FFFFFF",
                boxShadow: `
      0px 1px 2px 0px #00000005,
      0px 3px 3px 0px #00000005,
      0px 7px 4px 0px #00000003,
      0px 12px 5px 0px #00000000,
      0px 18px 5px 0px #00000000
    `,
                border: "none",
              }}
            >
              <Box
                sx={{
                  padding: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "pointer",
                }}
                onClick={() => setShowMessageContent(!showMessageContent)}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#2977CC",
                    fontWeight: 600,
                    fontSize: "22px",
                    borderBottom: "2px solid #2977CC",
                    display: "inline-block",
                    pb: 0.5,
                    marginX: 2,
                  }}
                >
                  Message
                </Typography>
                <Box>
                  {!showMessageContent && <MessaageRightIcon />}
                  {showMessageContent && <MessaageArrowUpIcon />}
                </Box>
              </Box>
              {showMessageContent &&
                (isMessageLoading ? (
                  <ListLoadingNew />
                ) : fetchMessgaeData.length === 0 &&
                  !isMessageLoading &&
                  !isMessageBox ? (
                  <Grid size={{ xs: 12, md: 12 }}>
                    <NoDataFound
                      isMessage={true}
                      title="No Conversation Yet"
                      subTitle="No conversation has been initiated yet. Once a message is sent or received, the conversation history will appear here."
                      handleData={() => {
                        getMessage(false);
                        setIsMessageBox(true);
                      }}
                       status={true}
                    />
                  </Grid>
                ) : (
                  <Box ref={messageEndRef} sx={{}}>
                    <MessageBox
                      fetchMessgaeData={fetchMessgaeData}
                      isPadding={true}
                      sentData={messageDetails}
                      sending={sending}
                    />

                    {isMessageBox ? (
                      <Box sx={{ padding: 3 }}>
                        <MessageEditor
                          handleSend={() => {
                            sendMessage();
                          }}
                          selectedFiles={selectedFiles}
                          setSelectedFiles={setSelectedFiles}
                          isMessageBox={setIsMessageBox}
                        />
                      </Box>
                    ) : (
                      <Box sx={{ textAlign: "end", padding: 3 }}>
                        <Button
                          type="submit"
                          sx={{
                            width: "120px",
                            height: "41px",
                            fontSize: "13.3px",
                            fontWeight: 600,
                            color: "#fff",
                            background:
                              "linear-gradient(98.24deg, #2977CC 4.13%, #1D538F 128.24%)",
                          }}
                          onClick={() => setIsMessageBox(true)}
                        >
                          Reply
                        </Button>
                      </Box>
                    )}
                  </Box>
                ))}
            </StyledGridBox>
          </Grid>
        </>
      )}

      <PreviewModal open={openPreview} handleClose={handleClose} img={img} />
    </Box>
  );
};

export default ApplyDetail;
